var objectGetPrototypeOf = require('../internals/object-get-prototype-of');
var anObject = require('../internals/an-object');
var CORRECT_PROTOTYPE_GETTER = require('../internals/correct-prototype-getter');

// `Reflect.getPrototypeOf` method
// https://tc39.github.io/ecma262/#sec-reflect.getprototypeof
require('../internals/export')({ target: 'Reflect', stat: true, sham: !CORRECT_PROTOTYPE_GETTER }, {
  getPrototypeOf: function getPrototypeOf(target) {
    return objectGetPrototypeOf(anObject(target));
  }
});



//////////////////
// WEBPACK FOOTER
// ../node_modules/core-js/modules/es.reflect.get-prototype-of.js
// module id = 214
// module chunks = 0